import { ChangeEvent } from 'react';

export const parseNumber = (onChange: (val: any) => void) => (
  e: ChangeEvent<HTMLInputElement>,
) => onChange(parseInt(e?.target?.value?.replace(/[^\d.]/g, '') || String(0)));
